import { GlobalService } from './../global.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { DataService } from '../data.service';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { ActionSheetController } from '@ionic/angular';
import { LoaderService } from '../loder_service/loader.service';
import { Base64 } from '@ionic-native/base64/ngx';
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
@Component({
  selector: 'app-editprofile',
  templateUrl: './editprofile.component.html',
  styleUrls: ['./editprofile.component.scss'],
})
export class EditprofileComponent implements OnInit {
public serverData:any;
public user_name:any;
public email:any;
public phone_number:any;
public address:any;
public city:any;
public pincode:any;
public state:any;
public pan_card:any;
public gst_no:any;
public image:any;
public user_image:any;
public cart_count:any=0;
public noti_count:any=0;
public new_notify_count:any;
  constructor(public globalService:GlobalService, private sanitizer: DomSanitizer,private base64: Base64,public router:Router, public toastService:LoaderService, public actionSheetController:ActionSheetController,public camera:Camera,public restApi:DataService, public storage:Storage ) { }

  ngOnInit() {}
ionViewWillEnter(){

    this.cart_count=localStorage.getItem('cart_count');
    if(localStorage.getItem('cart_count')){
      this.cart_count=localStorage.getItem('cart_count')
    }else{
      this.cart_count='';
    }
 
  
    if(localStorage.getItem('noti_count')){
      this.noti_count=localStorage.getItem('noti_count');
      //alert(this.cart_count)
    }else{
      this.noti_count=0;
    }


  this.toastService.showLoader('')

  if(localStorage.getItem('user_id')){
   console.log(localStorage.getItem('user_id'))
   let postparams={
     user_id:localStorage.getItem('user_id')
   }
   this.restApi.get_my_profile(postparams).subscribe((data:any)=>{
    this.toastService.hideLoader();
     this.serverData=data.profile_details
     this.user_name=this.serverData[0].seller_business_name
     this.email=this.serverData[0].seller_contact_person_email
     this.phone_number=this.serverData[0].seller_contact_person_phone
     
     this.pincode=this.serverData[0].pincode
     this.state="West Bengal"
     this.city=this.serverData[0].seller_contact_city
     this.address=this.serverData[0].seller_contact_address1
    
     
     console.log(this.user_image)
   },(error:any)=>{
    this.toastService.hideLoader();
   })
   }
     else{
     this.toastService.hideLoader();
      this.toastService.create('Please login.')
      this.router.navigate(['/signin'])
     }
 

 this.get_new_notification_list()
}
get_new_notification_list(){
  
    let postparams={
      usersessionId:localStorage.getItem('user_id')
    } 
    this.restApi.new_notification_list(postparams).subscribe((data:any)=>{
      this.new_notify_count=data.new_notify_count;
    },(error:any)=>{})
  
  
}
photoURL(url) {
  console.log(url)
  return this.sanitizer.bypassSecurityTrustResourceUrl(url);
 }
do_update(){
  this.toastService.showLoader('')

  let postparams={
    user_id:localStorage.getItem('user_id'),
    user_name:this.user_name,
    email:this.email,
    phone_number:this.phone_number,
    pincode:this.pincode,
    state:this.state,
    city:this.city,
    address:this.address,
  }
  console.log(postparams)
  this.restApi.update_profile(postparams).subscribe((data:any)=>{
    this.toastService.hideLoader();
    this.toastService.create('Your profile was successfully updated')
  },(error:any)=>{
    this.toastService.hideLoader();
    this.toastService.create('Having some issues from server end')
  })

}
async presentActionSheet() {
  const actionSheet = await this.actionSheetController.create({
    header: 'Albums',
    cssClass: 'my-custom-class',
    buttons: [{  
      text: 'Gallery',
      icon: 'images',
      handler: () => {
        console.log('Delete clicked');
        this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
      }
    }, {
      text: 'Camera',
      icon: 'camera',
      handler: () => {
        console.log('Share clicked');
        this.takePicture(this.camera.PictureSourceType.CAMERA);
      }
    }]
  });
  await actionSheet.present();
}
public takePicture(sourceType) {
  // Create options for the Camera Dialog
  const options: CameraOptions = {
    quality: 100,
    sourceType: sourceType,
    saveToPhotoAlbum: false,
    correctOrientation: true
  };
  
  this.camera.getPicture(options).then((imageData) => {
   // imageData is either a base64 encoded string or a file URI
   // If it's base64 (DATA_URL):
   this.user_image= 'data:image/jpeg;base64,' + imageData;

   let filePath: string = imageData;
this.base64.encodeFile(filePath).then((base64File: string) => {
  this.user_image = base64File;


  this.toastService.showLoader('');
 
   let postparams={
     user_id:localStorage.getItem('user_id'),
     image:this.user_image
   }
   this.restApi.update_profile_image(postparams).subscribe((data:any)=>{
     this.toastService.hideLoader() 
     this.toastService.create('Your profile updated successfully')
     this.globalService.publishSomeData({
       user_name:this.user_name,
       user_image:this.user_image,
       user_mobile:this.phone_number,
       user_id:localStorage.getItem('user_id')
   });

   },(error:any)=>{
     alert(JSON.stringify(error))
     this.toastService.hideLoader()
     this.toastService.create('Having some issues from server end');
   })//api
 


}, (err) => {
  //alert("error"+err);
});//base64

 // alert(this.user_image)
})//cameras
  }
  wallet(){
    this.router.navigate(['/wallet'])
  }
 // routerLink="/wallet"
 products(){
   this.router.navigate(['/products'])
 }
 search(){
   this.router.navigate(['/search"'])
 }
 gotoprofile(){
  this.router.navigateByUrl('/profile')
 }
 manageaddress(){
  this.router.navigateByUrl('/manageaddress')
 } 
 changpws(){
  this.router.navigateByUrl('/changpws')
 }
 //routerLink="/notifications"
 notifications(){
  this.router.navigateByUrl('/notifications')
 }
 cart(){
  this.router.navigateByUrl('/cart')
  
 }

}
